import { render, staticRenderFns } from "./remainList.vue?vue&type=template&id=dc6403ba&scoped=true&"
import script from "./remainList.vue?vue&type=script&lang=js&"
export * from "./remainList.vue?vue&type=script&lang=js&"
import style0 from "./remainList.vue?vue&type=style&index=0&id=dc6403ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6403ba",
  null
  
)

export default component.exports